import ATag, { type TagProps as ATagProps } from "antd/lib/tag";
import { CheckableTagProps as ACheckableTagProps } from "antd/lib/tag";

import styles from "./Tag.module.css";

export type TagProps = ATagProps;
export type CheckableTagProps = ACheckableTagProps;

export const Tag = Object.assign(
    ({ className, ...props }: TagProps) => {
        const combinedClassName = className ? `${styles.tag} ${className}` : styles.tag;
        return <ATag {...props} className={combinedClassName} />;
    },
    {
        CheckableTag: ATag.CheckableTag,
    },
);
